function roundUpCurrency(currency) {
  if (currency >= 1000000) {
    return currencyInMillions(currency)
  } else {
    return currencyInThousands(currency)
  }
}

function currencyInThousands(currency) {
  const currencyInThousands = currency / 1000;
  return Math.round(currencyInThousands * 10) / 10 + 'k';
}

function currencyInMillions(currency) {
  const currencyInMillions = currency / 1000000;
  return Math.round(currencyInMillions * 10) / 10 + 'm';
}

export default roundUpCurrency;
